import { render } from "./CertificateView.vue?vue&type=template&id=b94bc9ec&scoped=true"
import script from "./CertificateView.vue?vue&type=script&lang=js"
export * from "./CertificateView.vue?vue&type=script&lang=js"

import "./CertificateView.vue?vue&type=style&index=0&id=b94bc9ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94bc9ec"]])

export default __exports__